import { useEffect, useEffectEvent } from 'react'
import { onWsEvent, type WsMessage } from './client'

/** WS olayına abone olur; tek abonelik kalır, en güncel callback'ler çağrılır. */
export function useRealtime(match: (event: string) => boolean, onEvent: (msg: WsMessage) => void) {
  const handle = useEffectEvent((msg: WsMessage) => {
    if (match(msg.event)) onEvent(msg)
  })
  useEffect(() => onWsEvent((msg) => handle(msg)), [])
}
